import { render } from "./ESG.vue?vue&type=template&id=439c1fcb&scoped=true"
import script from "./ESG.vue?vue&type=script&lang=js"
export * from "./ESG.vue?vue&type=script&lang=js"

import "./ESG.vue?vue&type=style&index=0&id=439c1fcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439c1fcb"],['__file',"src/views/complaint/ESG.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "439c1fcb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('439c1fcb', __exports__)) {
    api.reload('439c1fcb', __exports__)
  }
  
  module.hot.accept("./ESG.vue?vue&type=template&id=439c1fcb&scoped=true", () => {
    api.rerender('439c1fcb', render)
  })

}


export default __exports__